import type { ReactElement } from "react"
import type { FetchPriority } from "~/types/mediaTypes"
import type { ResponsiveImages } from "~/types/squidex"
import ResponsiveImage from "../ResponsiveImage"
import ResponsiveVideo from "../ResponsiveVideo"

type ResponsiveMediaProps = {
  media: ResponsiveImages
  fetchPriority?: FetchPriority
  className?: string
}

enum FileType {
  MP4 = "mp4",
  WEBM = "webm",
  MOV = "mov",
}

function ResponsiveMedia({
  media,
  fetchPriority,
  className,
}: ResponsiveMediaProps): ReactElement | null {
  let videoAsset: ResponsiveImages = {
    large: [],
  }
  let imageAsset: ResponsiveImages = {
    large: [],
  }

  const validFileTypes = new Set(Object.values(FileType))

  for (let breakpoint of Object.keys(media)) {
    videoAsset = {
      ...videoAsset,
      [breakpoint]: media[breakpoint]
        ? media[breakpoint].filter((asset) =>
            validFileTypes.has(asset.fileType)
          )
        : null,
    }
  }

  for (let breakpoint of Object.keys(media)) {
    imageAsset = {
      ...imageAsset,
      [breakpoint]: media[breakpoint]
        ? media[breakpoint].filter(
            (asset) => !validFileTypes.has(asset.fileType)
          )
        : null,
    }
  }

  if (videoAsset.large.length > 0) {
    return <ResponsiveVideo video={videoAsset} />
  }

  if (imageAsset.large.length > 0) {
    return (
      <ResponsiveImage
        images={imageAsset}
        fetchPriority={fetchPriority}
        className={className}
      />
    )
  }

  return null
}

export default ResponsiveMedia
